// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__3aHV3","title":"Images90_title__1IDZp","images":"Images90_images__YkYyQ"};